import { AlignmentType, Paragraph, TextRun } from 'docx';

// Utils
import { htmlToSpacedPlainText } from '@/utils/htmlSerializer';
import { bodyRun, sectionHeading, sectionSpacer } from '../utils';

// Tokens
import { SECTION_TITLES } from '../../tokens';

// Constants
import {
  COLORS,
  FONT_FAMILY,
  FONT_SIZE,
  LINE_SPACING,
  SPACINGS,
} from '../constants';

export const PersonalInfoSection = (
  name: string,
  title: string,
  address: string,
  bio: string,
): Paragraph[] => {
  const paragraphs: Paragraph[] = [];

  if (name) {
    paragraphs.push(
      new Paragraph({
        spacing: { before: SPACINGS.displayMarginTop },
        children: [
          new TextRun({
            text: name,
            font: FONT_FAMILY,
            size: FONT_SIZE['4xl'],
            color: COLORS.foreground,
          }),
        ],
      }),
    );
  }

  if (title) {
    paragraphs.push(
      new Paragraph({
        spacing: {
          before: SPACINGS.displayMarginTop,
          after: SPACINGS.displayMarginTop,
        },
        children: [
          new TextRun({
            text: title,
            font: FONT_FAMILY,
            size: FONT_SIZE.lg,
            color: COLORS.secondary,
            bold: true,
          }),
        ],
      }),
    );
  }

  if (address) {
    paragraphs.push(
      new Paragraph({
        spacing: {
          after: SPACINGS.displayMarginBottom,
        },
        children: [
          new TextRun({
            text: address,
            font: FONT_FAMILY,
            size: FONT_SIZE.base,
            color: COLORS.secondary,
          }),
        ],
      }),
      new Paragraph({
        spacing: { after: SPACINGS.sectionGap },
      }),
    );
  }

  // Bio / Professional Profile
  const plainBio = htmlToSpacedPlainText(bio);

  if (plainBio) {
    paragraphs.push(
      sectionHeading(SECTION_TITLES.professionalProfile),
      new Paragraph({
        spacing: { line: LINE_SPACING },
        alignment: AlignmentType.JUSTIFIED,
        children: [bodyRun(plainBio)],
      }),
      sectionSpacer(),
    );
  }

  return paragraphs;
};
